import HeroWithCountdown from './heroWithCountdown'

export default HeroWithCountdown
